<template>
	<div>
		<el-drawer
			:title="`${data.assetName} -  变动详情`"
			:visible.sync="dialogVisible"
			size="45%"
			:close-on-click-modal="false"
			:before-close="handleClose"
			destroy-on-close>
			<div class="drawer-content">
				<el-tabs v-model="activeName" @tab-click="handleClick">
					<el-tab-pane label="基本信息" name="1" lazy>
						<AssetDynamicBaseInfo :data="detailData" />
					</el-tab-pane>
					<el-tab-pane label="审批记录" name="2" lazy>
						<AssetDynamicProgressRecord :data="detailData" />
					</el-tab-pane>
					<el-tab-pane label="关联资产" name="3" lazy>
						<AssetPlanAssetSelector :data="detailData" />
					</el-tab-pane>
				</el-tabs>
			</div>
		</el-drawer>
	</div>
</template>

<script>
	import AssetDynamicBaseInfo from './assetDynamicBaseInfo.vue';
	import AssetDynamicProgressRecord from './assetDynamicProgressRecord';
	import AssetPlanAssetSelector from './assetPlanAssetSelector';
	import { getAssetChangeGetById } from '@/api/asset/assetDynamicApi.js';
	export default {
		name: 'AssetDynamicDrawer',
		components: { AssetDynamicBaseInfo, AssetDynamicProgressRecord, AssetPlanAssetSelector },
		props: {
			dialogVisible: Boolean,
			data: {
				type: Object,
				default: () => ({}),
			},
		},
		watch: {
			dialogVisible(val) {
				if (val) {
					this.$nextTick(() => {
						this.activeName = '1';
						console.log(this.data, '111');

						this.fetchGetAssetChangeGetById(this.data.id);
					});
				}
			},
		},
		data() {
			return {
				activeName: '1',
				detailData: {},
			};
		},

		methods: {
			async fetchGetAssetChangeGetById(id) {
				const res = await getAssetChangeGetById(id);
				console.log(res, 'getAssetChangeGetById');
				this.detailData = res;
			},
			handleClick(tab, event) {
				console.log(tab, event);
			},
			handleClose() {
				this.$emit('update:dialogVisible', false);
			},
		},
	};
</script>

<style scoped lang="scss">
	.drawer-content {
		padding: 10px 24px;
		color: #666;
	}
</style>
